import React from 'react';

import BaseComponent from '../../baseClasses/BaseComponent'; // Change to point to the right level in the file structure
import ComboBox from '../ComboBox';

// Change DialogButton to the appropriate name
class StateComboBox extends BaseComponent {
  constructor(props) {
    super(props);
    let currentOption = props.currentOption ? props.currentOption : null;
    this.state = {
      stateList: [
        'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 
        'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 
        'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY', 
      ],
      selected: currentOption,
    };
  }

  createStateOptions(){

    let stateList  = this.state.stateList.map((state) => {
      return { type: state, name: state };
    });
    if (this.props.includeAll) {
      stateList.splice(0, 0, { type: 'all', name: '-- All States --' });
    }
    return stateList;
  }

  handleStateChange(type, option){
    let state = this.state.stateList.filter(function(state){
      return state == option.name;
    });
    state = state[0];
    this.setState({
      selected: state,
    });

    this.props.handleStateChange(state, option);
  }

  render() {
    let { height, width, hasBorder, defaultText, displayFontStyle, currentOption, maxHeight, top, left, label, tabIndex,
      makeAbsolute, underlined, menuHeight } = this.props;

    height = this.props.height ? this.props.height : null;
    width = this.props.width ? this.props.width : null;
    hasBorder = this.props.hasBorder ? this.props.hasBorder : null;
    defaultText = this.props.defaultText ? this.props.defaultText : null;
    displayFontStyle = this.props.displayFontStyle ? this.props.displayFontStyle : null;
    currentOption = this.props.currentOption ? this.props.currentOption : this.state.selected;
    maxHeight = this.props.maxHeight ? this.props.maxHeight : null;
    top = this.props.top ? this.props.top : null;
    left = this.props.left ? this.props.left : null;
    makeAbsolute = this.props.makeAbsolute ? this.props.makeAbsolute : null;
    label = this.props.label ? this.props.label : null;
    tabIndex = this.props.tabIndex ? this.props.tabIndex : null;
    underlined = this.props.underlined ? this.props.underlined : null;
    menuHeight = this.props.menuHeight ? this.props.menuHeight : null;

    let options = this.createStateOptions();

    return (
      // Replace with the appropriate HTML
      <ComboBox id={'statePicker'} options={options} height={height} width={width} hasBorder={hasBorder} defaultText={defaultText}
        currentOption={currentOption} displayFontStyle={displayFontStyle} handleSelection={this.handleStateChange}
        maxHeight={maxHeight} top={top} left={left} makeAbsolute={makeAbsolute} label={label} underlined={underlined}
        tabIndex={tabIndex} menuHeight={menuHeight} small={true}
    />
    );
  }
}

export default (StateComboBox);



// WEBPACK FOOTER //
// ./src/components/StateComboBox/index.js